module.exports = __webpack_public_path__ + "static/media/Portfolio.5447cbb0.PNG";